import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { storageKeys } from '@/config/storageKeys';

interface FavoriteAdminCardsState {
  favorites: string[];
  toggleFavorite: (cardId: string) => void;
}

// Shared by the dashboard (star toggle) and the admin header (links), and
// persisted per browser. The defaults only apply until the user stars a card.
export const useFavoriteAdminCards = create<FavoriteAdminCardsState>()(
  persist(
    (set) => ({
      favorites: ['onboarding', 'customers', 'users'],
      toggleFavorite: (cardId) =>
        set((state) => ({
          favorites: state.favorites.includes(cardId)
            ? state.favorites.filter((id) => id !== cardId)
            : [...state.favorites, cardId],
        })),
    }),
    { name: storageKeys.favoriteAdminCards },
  ),
);
